import { merge } from 'lodash';

class Annotation {
	constructor(panel, params = {}) {
		this.core = panel.core;
		this.panel = panel;
		this.params = merge(this._getDefaultParams(), params);
	}
}

export default Annotation;
